/**
 * Bernard Miniatures — « Voir plus d'avis ».
 *
 * La page des avis est rendue en entier par Liquid. Ce script ne fabrique rien :
 * il n'en montre qu'une vague au chargement, puis la suivante à chaque clic.
 * Quand la page est épuisée, le même bouton mène à la page suivante.
 *
 * Sans lui, tous les avis de la page restent visibles, avec la pagination du
 * thème en dessous.
 */

class BmAvisPlus extends HTMLElement {
  connectedCallback() {
    const grille = this.querySelector('[data-bm-avis-grille]');
    const pied = this.querySelector('[data-bm-avis-plus]');
    const bouton = pied?.querySelector('button');
    if (!grille || !bouton) return;

    this.vague = Number(this.dataset.vague) || 24;
    this.suivante = this.dataset.suivante;
    this.cartes = Array.from(grille.children);

    // La pagination du thème fait double emploi avec le bouton.
    const pagination = this.querySelector('[data-bm-avis-pagination]');
    if (pagination) pagination.hidden = true;

    this.cartes.slice(this.vague).forEach((carte) => (carte.hidden = true));
    this.#majBouton(pied);

    bouton.addEventListener('click', () => {
      const cachees = this.cartes.filter((carte) => carte.hidden);
      if (!cachees.length) {
        if (this.suivante) window.location.href = this.suivante;
        return;
      }

      const lot = cachees.slice(0, this.vague);
      lot.forEach((carte) => (carte.hidden = false));

      // Le focus suit le premier avis ajouté : au clavier comme au lecteur
      // d'écran, on repart de ce qu'on vient d'ouvrir.
      lot[0].tabIndex = -1;
      lot[0].focus({ preventScroll: true });

      this.#majBouton(pied);
    });
  }

  #majBouton(pied) {
    const reste = this.cartes.some((carte) => carte.hidden);
    pied.hidden = !reste && !this.suivante;
  }
}

if (!customElements.get('bm-avis-plus')) {
  customElements.define('bm-avis-plus', BmAvisPlus);
}
